import { render, staticRenderFns } from "./ManageEdiAccount.vue?vue&type=template&id=083397b8&"
import script from "./ManageEdiAccount.vue?vue&type=script&lang=js&"
export * from "./ManageEdiAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports